import { useEffect, useMemo, useRef } from "react";

import { selectRandomVariant } from "../../../../../utils/abTesting";
import { ShipperVoluntellLandingPageVariant } from "../types";
import { ShipperVoluntellActivationPage1 } from "./ShipperVoluntellActivationPage1";

import type { ActivationPageProps } from "../types";

interface ShipperVoluntellActivationPageRouterProps extends ActivationPageProps {
  onMetadataReady?: (metadata: Record<string, string>) => void;
}

export function ShipperVoluntellActivationPageRouter(
  props: ShipperVoluntellActivationPageRouterProps,
) {
  const { passwordField, submitButton, errorMessage, onMetadataReady } = props;

  // Roll the A/B variant once on mount. Computing it during render would
  // re-roll it on every keystroke (via Math.random), remounting a different
  // page and wiping the password field.
  const variant = useMemo(
    () => selectRandomVariant(ShipperVoluntellLandingPageVariant),
    [],
  );

  const calledMetadataRef = useRef<boolean>(false);

  useEffect(() => {
    if (calledMetadataRef.current) return;
    onMetadataReady?.({ landingPageVariant: variant });
    calledMetadataRef.current = true;
  }, [variant, onMetadataReady]);

  const pageProps = {
    passwordField,
    submitButton,
    errorMessage,
  };

  switch (variant) {
    case ShipperVoluntellLandingPageVariant.V1:
    default:
      return <ShipperVoluntellActivationPage1 {...pageProps} />;
  }
}
